import React, { Component } from "react";
import { numberToCurrency } from "../utility/global";
// import SaveIconWrap from './SaveIconWrap';
import OpenIconWrap from "./OpenIconWrap";
import ListIconWrap from "./ListIconWrap";

export default class ButtonWrap extends Component {
    // 簡易商品 api 取得目前畫面商品總金額
    render() {
        const {
            updateShowResultStatus,
            updateShowGetProductionJsonModal,
            updateShowProductionListModal,
            totalAmount,
        } = this.props;
        return (
            <div className="mx-0 mb-4 btnBar">
                <div className="row justify-content-between">
                    <div className="toolBtn__wrap col-4 col-md-2">
                        <OpenIconWrap
                            updateShowGetProductionJsonModal={
                                updateShowGetProductionJsonModal
                            }
                        />
                        <ListIconWrap
                            updateShowProductionListModal={
                                updateShowProductionListModal
                            }
                        />
                    </div>
                    {/* <div className="col-2 col-md-2"></div> */}
                    {/* 電腦版 */}
                    <div className="d-none d-md-block submit__wrap col-6 col-md-8">
                        <div className="d-flex justify-content-end">
                            <div className="amount__wrap">
                                <div className="amount text-right p-2 me-4">
                                    {numberToCurrency(totalAmount)}
                                </div>
                            </div>
                            <div className="d-flex">
                                <div
                                    className="submit btn"
                                    onClick={(e) => {
                                        updateShowResultStatus(true);
                                    }}>
                                    確認送出
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* 手機版 */}
                    <div className="d-md-none submit__wrap col-6 col-md-8">
                        <div className="row justify-content-end">
                            <div className="col-12 col-md-8 amount__wrap d-flex justify-content-end">
                                <div className="amount text-right p-2">
                                    {numberToCurrency(totalAmount)}
                                </div>
                            </div>
                            <div className="col-12 col-md-4 d-flex justify-content-end">
                                <div
                                    className="submit btn"
                                    onClick={(e) => {
                                        updateShowResultStatus(true);
                                    }}>
                                    確認送出
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
